require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");


require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/li-marquee");
require("./vendor/slick.min.js");
require("./functions/is_on_screen.es6");
require("./vendor/select2.js");

import AOS from 'aos';
import 'aos/dist/aos.css';

(function ($) {
    AOS.init();
    $("header").length > 0 && require("./template_parts/section_header.es6");
    $(".splash-home").length > 0 && require("./template_parts/section_splash_home.es6");
    $(".hero, .bio-hero").length > 0 && require("./template_parts/section_hero.es6");
    $(".progress-bar").length > 0 && require("./template_parts/section_progress_bar.es6");
    $(".strategy-home").length > 0 && require("./template_parts/section_strategy_home.es6");
    $(".strategy-home").length > 0 && require("./template_parts/section_careers_home.es6");
    $(".partners-home").length > 0 && require("./template_parts/section_partners_home.es6");
    $(".dots-bg").length > 0 && require("./functions/dots_bg.es6");
    $(".counter__items").length > 0 && require("./functions/counter.es6");
    $(".acf-map").length > 0 && require("./functions/google-map-acf.es6");
    $(".all-posts").length > 0 && require("./template_parts/section_all_posts.es6");
    $(".text-anim-title").length > 0 && require("./functions/text-animation.es6");

    if ($(".dots-bg").length > 0) {
        require("./functions/parallax.es6");
    }

    if ($(".timeline-items-wrapper").length > 0) {
        require("./template_parts/section_timeline.es6");
    }

    if ($(".parallax-text").length > 0) {
        require("./functions/parallax-text.es6");
    }

    if ($(".section-posts-slide").length > 0) {
        require("./template_parts/section_posts_slider.es6");
    }

    $(window).resize(function() {
        AOS.refresh()
    });
})(jQuery);